<div class="row justify-content-center mt-3 d-flex flex-lg-row-reverse">
    <div class="col-lg-6 col-12">
        <div class="row justify-content-center mt-4">
            <div class="col-8 blue_box p-4 text-center">
                <h4 class="heading">One Step Closer! Tell Us About Your Work</h4>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-11 white_box p-4">
                <form [formGroup]="model" (ngSubmit)="submit()" novalidate autocomplete="off">
                    <div class="row justify-content-center">
                        <div class="col-sm-10 col-12">

                            <!-- Document Type -->
                            <div class="form-group mt-3">
                                <label class="control-label">Business Document Type</label>
                                <select formControlName="documentType" class="form-select" required>
                                    <option value="" disabled selected>Select document type</option>
                                    <option value="GST">GST</option>
                                    <option value="Gumasta">Gumasta</option>
                                    <option value="Shop Establishment">Shop Establishment</option>
                                    <option value="Food License">Food License</option>
                                    <option value="Government provided business proof">Government provided business
                                        proof</option>
                                </select>
                            </div>

                            <!-- File Upload -->
                            <div class="form-group mt-4">
                                <label class="control-label">
                                    Upload Document {{model.get("documentType")?.value ? '(' +
                                    model.get("documentType")?.value + ')' : ''
                                    }} <span class="text-danger">*</span>
                                </label>
                                <input type="file" accept=".pdf,.jpg,.jpeg,.png" class="form-control mt-2"
                                    (change)="onFileSelected($event)" required />
                            </div>

                            <!-- Submit -->
                            <div class="text-center mt-4">
                                <button type="submit" class="btn btn-warning"
                                    [disabled]="!model.valid || !fileSelected">
                                    Personalize My Credit
                                    Line
                                </button>
                            </div>

                            <div>
                                <p class="text-center mt-4 footer-text">This helps us personalize the best travel credit
                                    line for you. It
                                    takes just
                                    a few seconds!​</p>
                            </div>

                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <div class="col-lg-5 col-11">
        <app-left-icons></app-left-icons>
    </div>
</div>
<ngx-spinner type="ball-spin-clockwise" size="medium"></ngx-spinner>